// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@tps/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { savedOrderListFilterStyles } from "@tps/Overrides/Widgets/SavedOrderList/SavedOrderListFilter";
import { mergeWithCss } from "@tps/XDL/Utilities";
import { css } from "styled-components";

savedOrderListFilterStyles.container = {
    ...mergeWithCss(myAccountFilterSectionStyles.searchFormStyles.wrapper, {
        gap: 10,
        offsetCss: css`
            &&& {
                width: 100%;
                margin: 0;
            }
        `,
        css: css`
            padding: 10px 15px;
        `,
    }),
};

savedOrderListFilterStyles.headingGridItem = {
    css: css`
        display: none;
    `,
};

savedOrderListFilterStyles.orderTotalGridItem = {
    ...myAccountFilterSectionStyles.orderTotalGridItem,
};

savedOrderListFilterStyles.orderTotalAmountTextField = {
    ...myAccountFilterSectionStyles.orderTotalAmountTextField,
};

savedOrderListFilterStyles.orderTotalOperatorGridItem = savedOrderListFilterStyles.orderTotalAmountGridItem = {
    ...myAccountFilterSectionStyles.mediumGridItem,
};

savedOrderListFilterStyles.datesGridItem = {
    ...myAccountFilterSectionStyles.datesGridItem,
};

savedOrderListFilterStyles.toGridItem = savedOrderListFilterStyles.fromGridItem = {
    ...myAccountFilterSectionStyles.mediumGridItem,
};

savedOrderListFilterStyles.clearFiltersButton = {
    ...myAccountFilterSectionStyles.clearButton,
};

savedOrderListFilterStyles.appliedFiltersContainer = {
    ...myAccountFilterSectionStyles.appliedFiltersContainer,
};

savedOrderListFilterStyles.appliedFilterTag = {
    ...myAccountFilterSectionStyles.appliedFilterTag,
};

savedOrderListFilterStyles.poNumberGridItem = {
    width: [12, 6, 3, 3, 3],
    css: css`
        padding: 10px;
    `,
};

savedOrderListFilterStyles.buttonsItem = {
    width: [12, 6, 9, 9, 9],
    css: css`
        justify-content: flex-end;
        padding: 10px;
    `,
};
